module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/409a833317adc76a00df655bd87ef43f.png";